import React, { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim"; 

const ParticlesBackground = () => {
    const particlesInit = useCallback(async (engine) => {
        console.log(engine);
        await loadSlim(engine); 
    }, []);

    const particlesLoaded = useCallback(async (container) => {
        console.log(container);
    }, []);

    return (
        <div
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                pointerEvents: "none",
                zIndex: 1, 
            }}
        >
            <Particles
                id="tsparticles"
                init={particlesInit}
                loaded={particlesLoaded}
                options={{
                    background: {
                        color: {
                            value: "transparent", 
                        },
                    },
                    fpsLimit: 60, 
                    interactivity: {
                        events: {
                            onClick: { enable: false },
                            onHover: { enable: false }, 
                            resize: true,
                        },
                    },
                    particles: {
                        number: {
                            density: { enable: true, area: 1000 }, 
                            value: 100,
                        },
                        color: { value: "#ffffff" }, 
                        move: {
                            direction: "none",
                            enable: true,
                            outModes: { default: "out" },
                            random: true,
                            speed: 0.3, 
                            straight: false,
                        },
                        opacity: {
                            value: { min: 0.1, max: 1 }, 
                            animation: {
                                enable: true,
                                speed: 1,
                                minimumValue: 0.1, 
                                sync: false,
                            },
                        },
                        size: {
                            value: { min: 1, max: 2 },
                            animation: {
                                enable: true,
                                speed: 1,
                                minimumValue: 0.1,
                                sync: false,
                            },
                        },
                        shape: {
                            type: "circle",
                        },
                    },
                    detectRetina: true,
                }}
            />
        </div>
    );
};

export default ParticlesBackground;
